import React, { useState } from "react";
import { navigate } from "gatsby";
import MobileContainer from "../../Containers/MobileContainer";
import TelecelMobile from "../../SVG/mobile/telecel_mobile_logo";
import SearchMobile from "../../SVG/mobile/search_mobile";
import Xclose from "../../SVG/mobile/xclose";
import Avatar from "../../SVG/web/avatar";
import Hamburger from "../../SVG/mobile/hamburger";
import VerticalNavDrawer from "../../layout/Drawers/verticalNavDrawer";
import {
  Password,
  UserPlus,
  Table,
  SignOut,
  SignIn,
  User,
  UserSwitch,
} from "@phosphor-icons/react";
import Modal from "../../../components/interface/Modals";
import Loader from "../../../components/interface/Loaders/buttonLoader";
import { redirectToLoginPage } from "../../../utilities/redirect-to-login.js";
import {
  getServiceList,
  getUser,
  isBrowser,
} from "../../../services/CurrentUser/currentUserLocalStorage.js";
import { updateDefaultService } from "../../../services/profile-services.js";
import {
  findDefaultServicePrimaryId,
  findServiceIdWithPrimaryId,
  getDefaultServiceType,
  updateUserWithDefaultService,
} from "../../../utilities/account-service-utils.js";
import { toast, Toaster } from 'sonner';

const MobileNavigation = ({
  menuData,
  PageLevel,
  useInitials,
  userProfileImage,
  userIsSigned,
  handleUserLogout,
  urlPathName,
  pathSegments,
  userType,
  dashBoardUrl,
}) => {
  const [username, setUsername] = useState(getUser().username);
  const [serviceList, setServiceList] = useState(getServiceList());
  const [currentService, setCurrentService] = useState("");
  const [showSwitchAccount, setShowSwitchAccountModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [secondActiveIndex, setSecondActiveIndex] = useState(null);
  const [thirdActiveIndex, setThirdActiveIndex] = useState(null);
  const [showAccountDropDown, setShowAccountDropDown] = useState(false);
  const toggleNavigation = (e) => {
    e.preventDefault();
    setToggleDrawer(!toggleDrawer);
    if (toggleDrawer) {
      setActiveIndex(null);
      setSecondActiveIndex(null);
      setThirdActiveIndex(null);
    }
  };

  const toggleMenus = () => {
    setShowAccountDropDown(!showAccountDropDown);
  };

  const handleCloseModal = () => {
    setShowSwitchAccountModal(false);
  };

  const handleServiceListChange =(value, name)=>{
    setCurrentService(value)
}

  async function handleServiceSwitch(primaryID) {
    // console.log(primaryID)
    if(!primaryID){
      toast.error("Please select a service", { duration: 5000, position: "top-right" });
      return;
    }
    setLoader(true)
    try {
      const desiredServiceId = await findServiceIdWithPrimaryId(
        primaryID
      );
      // console.log("desiredServiceId", desiredServiceId)
      if (!!desiredServiceId) {
        const res = await updateDefaultService(username, desiredServiceId);
        if (
          res.data.response_code === 422 ||
          res.data.response_code === "422"
        ) {
          toast.error("sorry an issue occurred, please try again later", { duration: 5000, position: "top-right" });
        }
        if (res.success === true) {
          // console.log("update service response", res.data);
          toast.success("service account switched succesfully", { duration: 5000, position: "top-right" });
          updateUserWithDefaultService(res.data.RESPONSEDATA);
          let serviceType = getDefaultServiceType();
          isBrowser() && window.location.reload();
        }
      } else {
        toast.error("sorry an issue occurred, please try again later", { duration: 5000, position: "top-right" });
      }
      // setShowSwitchAccountModal(false)
      setLoader(false)
    } catch (error) {
      // console.error("service switch error", error);
      setLoader(false)
    }
  }

  return (
    <div className="block bg-white md:hidden fixed w-full z-40 border-b border-b-gray_200">
              <Toaster richColors />
      {showSwitchAccount && (
        <Modal
          handleClose={handleCloseModal}
          Content={
            <ModalContent
              handleServiceListChange={handleServiceListChange}
              serviceList={serviceList}
              currentService={currentService}
              handleProceed={handleServiceSwitch}
              loader={loader}
            />
          }
          Title="Switch Service Account"
        />
      )}
      <div
        onClick={toggleNavigation}
        className={`bg-opacity-90 h-screen absolute w-full left-0 bg-black transition-all ${
          toggleDrawer ? "block" : "hidden"
        } `}
      >
        <div className="flex justify-end h-16 items-center w-[90%]">
          <button
            onClick={toggleNavigation}
            className="h-full flex justify-center items-center mt-2"
          >
            <Xclose />
          </button>
        </div>
      </div>
      <MobileContainer>
        <div className="">
          <div className="h-18">
            <div className="h-full w-full flex justify-between items-center">
              <div
                className="cursor-pointer"
                onClick={() => {
                  // navigate to url here when we change it... it currently window.location.href
                  // if (userIsSigned) {
                  //   window.location.href = dashBoardUrl;
                  // } else {
                  //   window.location.href = `${process.env.Telecel_web_url}";
                  // }
                  window.location.href = `${process.env.Telecel_web_url}`
                }}
              >
                <TelecelMobile />
              </div>
              <div className="flex gap-6 items-center">
                {/* <button>
                  <SearchMobile/>
                </button> */}
                {userIsSigned ? (
                  <>
                    {userProfileImage ? (
                      <div className="w-10 h-10 rounded-full border flex items-center justify-center">
                        <img
                          src={userProfileImage}
                          alt="profile icon"
                          className="w-full h-full object-cover rounded-full"
                        />
                      </div>
                    ) : (
                      <button
                        className="w-10 h-10 rounded-full hover:ring-2 border-2 hover:ring-brand flex items-center text-negative tracking-wide font-semibold bg-red_200 justify-center"
                        onClick={(e) => {
                          toggleMenus();
                        }}
                      >
                        {useInitials}
                      </button>
                    )}
                  </>
                ) : (
                  <button
                    className=" bg-surface_subtle hover:bg-surface_default rounded-full p-3"
                    onClick={() => window.location.href = "/"}
                  >
                    <User size={20} />
                  </button>
                )}
                <button onClick={toggleNavigation}>
                  <Hamburger />
                </button>
                {showAccountDropDown ? (
                  <>
                    {userIsSigned ? (
                      <div className="w-50 absolute top-full right-0 flex flex-col items-start justify-center bg-white border border-border_lighter rounded-md shadow-lg">
                             {userType !== "enterprise" && (
                              <button
                                className="w-full p-4 text-body_base text-left transition-all hover:bg-brand hover:text-telecel_white rounded-md flex justify-between items-center"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowSwitchAccountModal(true);
                                }}
                              >
                                Switch Account <UserSwitch size={20} />
                              </button>
                            )}
                        <button
                          className="w-full p-4 text-body_base text-left transition-all hover:bg-brand hover:text-telecel_white rounded-md flex justify-between items-center"
                          onClick={(e) =>
                            e.preventDefault()
                            // navigate to url here when we change it... it currently window.location.href
                            (window.location.href = dashBoardUrl)
                          }
                        >
                          Dashboard <Table size={20} />
                        </button>
                        <button className="w-full p-4 text-body_base text-left transition-all hover:bg-brand hover:text-telecel_white rounded-md flex justify-between items-center"   onClick={(e) => {
                          e.preventDefault()
                              // navigate(
                              //  "/account-details/"
                              // );
                              window.location.href =  "/account-details/"
                            }}>
                          Manage Account{" "}
                          <UserPlus
                            size={20}
                          
                          />
                        </button>
                        <button
                          className="w-full p-4 text-body_base text-left transition-all hover:bg-brand hover:text-telecel_white rounded-md flex justify-between items-center"
                          onClick={() =>{

                            // navigate("/personal/telecel-play/reset-password/")
                            window.location.href =  "/reset-password/"
                          }

                          }
                        >
                          Forgot Password <Password size={20} />
                        </button>
                        <button
                          className="w-full p-4 text-body_base text-left transition-all hover:bg-brand hover:text-telecel_white rounded-md flex justify-between items-center"
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserLogout();
                          }}
                        >
                          Logout <SignOut size={20} />
                        </button>
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </MobileContainer>
      <div>
        <VerticalNavDrawer
          toggle={toggleDrawer}
          onToggle={toggleNavigation}
          menuItems={menuData}
          PageLevel={PageLevel}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          secondActiveIndex={secondActiveIndex}
          setSecondActiveIndex={setSecondActiveIndex}
          thirdActiveIndex={thirdActiveIndex}
          setThirdActiveIndex={setThirdActiveIndex}
          useInitials={useInitials}
          urlPathName = {urlPathName}
          pathSegments = {pathSegments}
          // userProfileImage={userProfileImage}
          userIsSigned={userIsSigned}
          handleUserLogout = {handleUserLogout}
          userType={userType}
        />
      </div>
    </div>
  );
};

export default MobileNavigation;

const ModalContent = ({
  handleServiceListChange,
  serviceList,
  currentService,
  handleProceed,
  loader,
}) => {
  const { serviceList: services } = serviceList;
  // console.log("services", services)
  return (
    <>
      <p className="mt-7 rounded-lg text-center px-5 pt-8 pb-10 border border-surface_default bg-gradient-to-r from-brand to-orange_500 text-negative font-semibold text-body_base">
        Select an account and proceed
      </p>
      <div className="mt-6">
        <div className={`w-full py-1`}>
          <label htmlFor={"switch"}>
            <span className={`text-body_base font-bold`}>
              {"Switch Service"}
            </span>
            <span className="text-brand"> *</span>
          </label>
          <select
            className="w-full bg-surface_subtle shadow-inner-sm focus:border-border_lighter outline-none p-3 my-1 rounded-lg border border-border_default"
            value={currentService}
            required
            onChange={(e) => {
              handleServiceListChange(e.target.value, e.target.name);
            }}
          >
            <option value="" disabled defaultValue={``}>
              Select Service
            </option>
            {services.map((service, i) => (
              <option key={i} value={service.primaryID}>
                {service.DisplayName.toLowerCase().charAt(0).toUpperCase() +
                  service.DisplayName.toLowerCase().slice(1)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-4 w-full">
        <button
          disabled={loader === true}
          className="rounded-full flex justify-center items-center gap-2 bg-telecel_red text-telecel_white px-4 py-4 w-full "
          onClick={(e) => {
            e.preventDefault();
            handleProceed(currentService);
          }}
        >
          {loader ? <Loader /> : <p className="text-body_sm">{"Proceed"}</p>} 
        </button>
      </div>
    </>
  );
};
